"use strict";import{PickerButton as e}from"./src/PickerButton.js";import{defineElement as t}from"@spectrum-web-components/base/src/define-element.js";t("sp-picker-button",e);
//# sourceMappingURL=sp-picker-button.js.map
